import { render, staticRenderFns } from "./mainMenu.vue?vue&type=template&id=73963b7b&scoped=true"
import script from "./mainMenu.vue?vue&type=script&lang=js"
export * from "./mainMenu.vue?vue&type=script&lang=js"
import style0 from "./mainMenu.vue?vue&type=style&index=0&id=73963b7b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73963b7b",
  null
  
)

export default component.exports